// Platform logo configuration with CDN URLs for official social media logos
export const platformLogos = {
  facebook: {
    id: 'facebook',
    name: 'Facebook',
    logo: "/assets/images/Facebook_Logo_Primary-1765301173344.png",
    alt: 'Facebook logo - blue lowercase f on white background',
    color: '#1877F2',
    charLimit: 63206
  },
  instagram: {
    id: 'instagram',
    name: 'Instagram',
    logo: "/assets/images/Instagram_Glyph_Black-1765304118643.png",
    alt: 'Instagram logo - black monochromatic camera icon with rounded square border, circular lens, and viewfinder dot in minimalist design',
    color: '#E4405F',
    charLimit: 2200
  },
  twitter: {
    id: 'twitter',
    name: 'X',
    logo: "/assets/images/logo-black-1765301918811.png",
    alt: 'X logo - black stylized X symbol (formerly Twitter)',
    color: '#000000',
    charLimit: 280
  },
  linkedin: {
    id: 'linkedin',
    name: 'LinkedIn',
    logo: "/assets/images/LI-In-Bug-1765304443047.png",
    alt: 'LinkedIn logo - blue rounded square with white lowercase "in" text and registered trademark symbol',
    color: '#0A66C2',
    charLimit: 3000
  },
  tiktok: {
    id: 'tiktok',
    name: 'TikTok',
    logo: "/assets/images/TikTok_Icon_Black_Circle-1765303860904.png",
    alt: 'TikTok logo - black circular icon with cyan, white and pink musical note design creating 3D effect',
    color: '#000000',
    charLimit: 2200
  },
  reddit: {
    id: 'reddit',
    name: 'Reddit',
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_188a5b375-1768422557253.png",
    alt: 'Reddit logo - orange circular icon with white smiling alien mascot (Snoo)',
    color: '#FF4500',
    charLimit: 40000
  }
};

// Helper function to get platform config by ID
export const getPlatformConfig = (platformId) => {
  return platformLogos?.[platformId] || null;
};

// Get all platforms as array
export const getAllPlatforms = () => {
  return Object.values(platformLogos);
};